"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientContractTable = exports.ClientContractProvider = void 0;
const mithril_1 = __importDefault(require("mithril"));
const helpers_1 = require("../../../utils/helpers");
const rest_provider_1 = require("../../../utils/rest_provider");
const table_renderers_1 = require("../../../utils/table_renderers");
const table_1 = require("../../../widgets/table");
const invoice_print_1 = require("../invoice/invoice_print");
const contract_print_1 = require("./contract_print");
exports.ClientContractProvider = new rest_provider_1.RestProvider({
    name: "client_contract",
    create: "",
    update: "",
    show: "",
    delete: "",
    index: "GET|/me/contracts",
    new: ""
});
exports.ClientContractTable = (0, table_1.createTable)({
    id: "clientContractTable",
    provider: exports.ClientContractProvider,
    title: "Mes forfait(s) en cours",
    topMenuRight: () => {
        return undefined;
    },
    rowRenderer: (mdl, row) => {
        if (!mdl.active) {
            return (0, mithril_1.default)("tr", { style: "text-decoration: line-through; color: #999;" }, row);
        }
        else {
            return (0, mithril_1.default)("tr", row);
        }
    },
    filters: [],
    fields: [
        {
            name: "contracts.id",
            sortable: true,
            label: "#",
            renderer: (x) => x.id
        },
        {
            name: "offers.name",
            sortable: true,
            label: "Offre",
            renderer: table_renderers_1.TableRenderers.tag((mdl) => mdl.offer.name)
        },
        {
            name: "remaining_minutes",
            sortable: true,
            label: "Crédit restant",
            renderer: table_renderers_1.TableRenderers.time
        },
        {
            name: "remaining_cancelable_free_minutes",
            sortable: true,
            label: "Quota d'annulation gratuite restant",
            renderer: table_renderers_1.TableRenderers.time
        },
        {
            name: "created_at",
            sortable: true,
            label: "Signé le",
            renderer: table_renderers_1.TableRenderers.dateOnly
        },
        {
            name: "active",
            sortable: false,
            label: "Actif",
            renderer: table_renderers_1.TableRenderers.bool
        },
        {
            name: "expires_at",
            sortable: true,
            label: "Date d'expiration",
            renderer: table_renderers_1.TableRenderers.date
        },
    ],
    actions: (obj) => {
        var _a;
        return (0, mithril_1.default)("div", { class: "" }, (0, mithril_1.default)("a.button.is-primary.with-margin", { href: contract_print_1.ContractPrint.link(obj.id), target: "_blank" }, (0, helpers_1.iconSpan)("fa-eye"), (0, mithril_1.default)("span", "Contrat")), (0, helpers_1.ifTrue)((_a = obj.invoice) === null || _a === void 0 ? void 0 : _a.id, (0, mithril_1.default)("a.button.is-info.with-margin", { href: invoice_print_1.InvoicePrint.link(obj.invoice.id), target: "_blank" }, (0, helpers_1.iconSpan)("fa-file"), (0, mithril_1.default)("span", "Facture"))));
    }
});
